'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeviceSetupTagline = exports.DeviceSetupTaglineUnwrapped = exports.mapStateToProps = exports.formConfig = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _reduxForm = require('redux-form');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _deviceSetupModal = require('containers/DeviceSetupModal/device-setup-modal.saga');

var _InputField = require('../FormFields/InputField');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = exports.formConfig = {
  form: 'device-setup-tagline'
};

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  var userProfile = state.entities.userProfile.data.default;
  return {
    initialValues: {
      tagline: userProfile.tagline
    }
  };
};

var DeviceSetupTaglineUnwrapped = exports.DeviceSetupTaglineUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(DeviceSetupTaglineUnwrapped, _React$Component);

  function DeviceSetupTaglineUnwrapped() {
    var _ref;

    var _temp, _this, _this2, _ret;

    (0, _classCallCheck3.default)(this, DeviceSetupTaglineUnwrapped);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = _this = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref = DeviceSetupTaglineUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(DeviceSetupTaglineUnwrapped)).call.apply(_ref, [this].concat(args))), _this2), _this2.handleSubmit = function (event) {
      var handleSubmit = _this.props.handleSubmit;


      handleSubmit(_deviceSetupModal.submitUserInformation)(event);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this2, _ret);
  }

  (0, _createClass3.default)(DeviceSetupTaglineUnwrapped, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          image = _props.image,
          username = _props.username,
          submitting = _props.submitting;


      return _react2.default.createElement(
        'div',
        { className: 'modal__device-tagline' },
        _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__top' },
          _react2.default.createElement(_reactIntl.FormattedMessage, {
            id: 'device.profie-header',
            defaultMessage: 'Profile',
            tagName: 'h3'
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'modal__device-setup__content' },
          _react2.default.createElement('img', { src: image, alt: username, className: 'modal__device-setup__profile-img' }),
          _react2.default.createElement(
            'p',
            { className: 'mt' },
            username
          ),
          _react2.default.createElement(
            'form',
            { onSubmit: this.handleSubmit },
            _react2.default.createElement(_reduxForm.Field, {
              component: _InputField.InputField,
              name: 'tagline',
              inputClassNames: 'modal__device-tagline__input mt mb++',
              inputAttributes: {
                maxLength: 20,
                placeholder: 'Enter a tagline or location'
              }
            }),
            _react2.default.createElement(
              'button',
              {
                type: 'submit',
                disabled: submitting,
                className: 'bt bt--primary bt--width-md mb',
                key: 'device.welcome.button'
              },
              'Next'
            )
          )
        )
      );
    }
  }]);
  return DeviceSetupTaglineUnwrapped;
}(_react2.default.Component);

DeviceSetupTaglineUnwrapped.propTypes = {
  handleSubmit: _propTypes2.default.func,
  image: _propTypes2.default.string,
  username: _propTypes2.default.string,
  submitting: _propTypes2.default.bool
};

var DeviceSetupTagline = exports.DeviceSetupTagline = (0, _reactRedux.connect)(mapStateToProps)((0, _reduxForm.reduxForm)(formConfig)(DeviceSetupTaglineUnwrapped));